import { createReducer, createTypes } from 'reduxsauce';

export const parqueTypes = createTypes(
  `
      SET_THINGS
      SET_THINGS_DATA
      SET_THING
      SET_ZONES
      SET_PARKS_CUSTOMER
      SET_ZONES_CUSTOMER
      SET_SELECTED_PARK_CUSTOMER
  `,
  { prefix: 'PARQUE/' }
);

const INITIAL_STATE = {
  zones: [],
  customer: {
    selectedPark: {},
  },
  initializing: true,
};

// Reducers
const setThingsData = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    thingsData: action.payload,
  };
};

const setThings = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    things: action.payload,
  };
};

const setThing = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    thing: action.payload,
  };
};

const setZones = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    zones: action.zones,
  };
};

const setParksCustomer = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    customer: {
      ...state.customer,
      parks: action.parks,
    },
  };
};

const setSelectedPark = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    customer: {
      ...state.customer,
      selectedPark: action.park,
    },
  };
};

export default createReducer(INITIAL_STATE, {
  [parqueTypes.SET_THINGS]: setThings,
  [parqueTypes.SET_THING]: setThing,
  [parqueTypes.SET_ZONES]: setZones,
  [parqueTypes.SET_PARKS_CUSTOMER]: setParksCustomer,
  [parqueTypes.SET_SELECTED_PARK_CUSTOMER]: setSelectedPark,
  [parqueTypes.SET_THINGS_DATA]: setThingsData,
});
